<template>
  <div>
    <h1>Prévisionnel sur TOP 50 Fournisseur CMEM</h1>
    <br />
    <div class="result-container">
      <button class="btn btn-success" v-on:click="exportDatas('prevision')">Exporter sous Excel</button>
      <h2>Données du fournisseur {{this.frsName}}</h2>
      <vue-good-table :columns="columns"
                      :rows="rows"
                      :sort-options="{enabled: true, initialSortBy: {field: 'CaN1', type: 'desc'}}"
                      :pagination-options="{
                        enabled: false,
                      }"
                      :group-options="{
                        enabled: true,
                        headerPosition: 'top',
                        collapsable: false,
                      }">
      </vue-good-table>
    </div>
  </div>
</template>
<script>
  import { getFrsPreviResults } from "@/utils/frs";
  import { getParameterByCode } from "@/utils/param";
  import { exportExcel } from "@/utils/exportExcel";

  export default {
    name: "TopFrsPrevisionnelSupplier",
    components: {
    },
    data() {
      return {
        frsGuid: "",
        frsName: "",
        rows: [],
        currentYear: 0
      }
    },
    mounted() {
      this.frsGuid = this.$route.query.frsGuid;
      this.frsName = this.$route.query.frsName;

      getParameterByCode("ANNEE_COURANTE").then(res => {
        this.currentYear = parseInt(res);
      })
      getFrsPreviResults(this.frsGuid).then(res => {
        this.rows = [
          {
            GroupeName: "Totaux",
            children: res
          }
        ]
      });
    },
    computed: {
      columns() {
        return [
          { label: "Groupe", field: "GroupeName", filterOptions: { enabled: true, } },
          { label: "Société", field: "SocieteName", filterOptions: { enabled: true, } },
          { label: "Code Compta", field: "SocieteIdCompta", filterOptions: { enabled: true } },
          { label: "CA " + (this.currentYear - 2), field: "CaN2", headerField: this.generateSumBy("CaN2"), type: "number", formatFn: this.formatNbEur },
          { label: "CA " + (this.currentYear - 1), field: "CaN1", headerField: this.generateSumBy("CaN1"), type: "number", formatFn: this.formatNbEur },
          { label: "Part de Marché " + (this.currentYear - 1), field: "PdmN1", type: "number", formatFn: this.formatNbPercent },
          { label: "Progression " + (this.currentYear - 2) + "/" + (this.currentYear - 1), field: "ProgressionN1N2", headerField: this.generateProgressionBy("CaN2", "CaN1"), type: "number", formatFn: this.formatNbPercent },
          { label: "CA Estimé " + this.currentYear, field: "EstimatedCaN", headerField: this.generateSumBy("EstimatedCaN"), type: "number", formatFn: this.formatNbEur },
          { label: "Progression " + (this.currentYear - 1) + "/" + this.currentYear, field: "ProgressionNN1", headerField: this.generateProgressionBy("CaN1", "EstimatedCaN"), type: "number", formatFn: this.formatNbPercent },
          { label: "CA Prévu " + (this.currentYear + 1), field: "CaNp1", headerField: this.generateSumBy("CaNp1"), type: "number", formatFn: this.formatNbEur },
          { label: "Progression " + (this.currentYear - 1) + "/" + (this.currentYear + 1), field: "ProgressionNp1N1", headerField: this.generateProgressionBy("EstimatedCaN", "CaNp1"), type: "number", formatFn: this.formatNbPercent },
        ]
      }
    },
    methods: {
      generateSumBy(field) { // Retourne une fonction de somme basée sur le champs (field) envoyé en paramètre
        return function (rowObj) {
          return rowObj.children.reduce((acc, el) => el[field] + acc, 0);
        }
      },
      generateProgressionBy(fieldN, fieldNp1) { // Retourne une fonction de progression moyenne basée sur les champs de CA N - 1 et N envoyés en paramètres
        return function (rowObj) {
          const CaN = rowObj.children.reduce((acc, el) => el[fieldN] + acc, 0);
          const CaNp1 = rowObj.children.reduce((acc, el) => el[fieldNp1] + acc, 0);
          if (CaN == 0 && CaNp1 == 0) return 0;
          else if (CaN == 0) return 100;

          return ((CaNp1 - CaN) / CaN) * 100;
        }
      },
      formatNbEur(n) {
        return n.toLocaleString("fr-FR", { maximumFractionDigits: 0 });
      },
      formatNbPercent(n) {
        n = n / 100;
        return n.toLocaleString("fr-FR", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 })
      },

      exportDatas() { // Génère un export excel
        exportExcel(this.columns, this.rows[0].children, "Données previsionnelles fournisseur " + this.frsName + " " + this.currentYear)
      },
    }
  }
</script>

<style scoped>
  .saisie-container, .result-container {
    margin-top: 48px;
  }

  table {
    background: #FFFFFF;
    border-radius: 5px;
    font-size: 0.9em;
  }

    table > thead > tr > th {
      padding-top: 15px;
      padding-bottom: 15px;
      font-weight: 100;
      font-size: 1.2em;
      text-align: center;
      vertical-align: middle;
    }

    table > tbody {
      border-top: solid 2px #999999 !important;
    }

    table .table-info {
      font-weight: bold;
    }

  td.bordered, th.bordered {
    border-right: 1px solid #EEE;
  }

  td.nb {
    text-align: right;
  }

  td.green {
    color: #30CC30 !important;
  }

  td.red {
    color: #CC3030 !important;
  }

  h2 {
    font-weight: 100;
    font-size: 1.6em;
  }

  .btn {
    float: right;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Achat/TopFrsPrevisionnelSupplier.vue